import "./styles.css";
import BackGrad from "./components/BackGrad";

export default function App() {
  return (
    <div className="App">
      <BackGrad />
      <div className="header">
        <h1 className="title">CallStack Collective Console</h1>
      </div>
    </div>
  );
}
